import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import "../../core/has.js";
import e from "../../core/Error.js";
import { JSONSupport as s } from "../../core/JSONSupport.js";
import { clone as i } from "../../core/lang.js";
import r from "../../core/Logger.js";
import { isNone as l } from "../../core/maybe.js";
import { property as a } from "../../core/accessorSupport/decorators/property.js";
import { cast as o } from "../../core/accessorSupport/decorators/cast.js";
import { subclass as h } from "../../core/accessorSupport/decorators/subclass.js";

var _n;

var p = r.getLogger("esri.layers.support.PixelBlock");

var c = _n = /*#__PURE__*/function (_s) {
  _inherits(n, _s);

  var _super = _createSuper(n);

  function n(t) {
    var _this;

    _classCallCheck(this, n);

    _this = _super.call(this, t), _this.width = null, _this.height = null, _this.pixelType = "f32", _this.validPixelCount = null, _this.mask = null, _this.maskIsAlpha = !1, _this.pixels = null, _this.statistics = null;
    return _this;
  }

  _createClass(n, [{
    key: "castPixelType",
    value: function castPixelType(t) {
      if (!t) return "f32";
      var e = t.toLowerCase();
      return ["u1", "u2", "u4"].indexOf(e) > -1 ? e = "u8" : -1 === ["unknown", "u8", "s8", "u16", "s16", "u32", "s32", "f32", "f64"].indexOf(e) && (e = "f32"), e;
    }
  }, {
    key: "getPlaneCount",
    value: function getPlaneCount() {
      return this.pixels && this.pixels.length;
    }
  }, {
    key: "addData",
    value: function addData(t) {
      if (!t.pixels || t.pixels.length !== this.width * this.height) throw new e("pixelblock:invalid-or-missing-pixels", "add data requires valid pixels array that has same length defined by pixel block width * height");
      this.pixels || (this.pixels = []), this.statistics || (this.statistics = []), this.pixels.push(t.pixels), this.statistics.push(t.statistics || {
        minValue: null,
        maxValue: null
      });
    }
  }, {
    key: "getAsRGBA",
    value: function getAsRGBA() {
      var t = new ArrayBuffer(this.width * this.height * 4);

      switch (this.pixelType) {
        case "s8":
        case "s16":
        case "u16":
        case "s32":
        case "u32":
        case "f32":
        case "f64":
          this._fillFromNon8Bit(t);

          break;

        default:
          this._fillFrom8Bit(t);

      }

      return new Uint8ClampedArray(t);
    }
  }, {
    key: "getAsRGBAFloat",
    value: function getAsRGBAFloat() {
      var t = new Float32Array(this.width * this.height * 4);
      return this._fillFrom32Bit(t), t;
    }
  }, {
    key: "updateStatistics",
    value: function updateStatistics() {
      var _this2 = this;

      this.statistics = this.pixels.map(function (t) {
        return _this2._calculateBandStatistics(t, _this2.mask);
      });
      var t = this.mask;
      var e = 0;
      if (t) for (var _s2 = 0; _s2 < t.length; _s2++) {
        t[_s2] && e++;
      } else e = this.width * this.height;
      this.validPixelCount = e;
    }
  }, {
    key: "clamp",
    value: function clamp(t) {
      if (!t || "f64" === t || "f32" === t) return;
      var e;

      switch (t) {
        case "u8":
          e = [0, 255];
          break;

        case "u16":
          e = [0, 65535];
          break;

        case "u32":
          e = [0, 4294967295];
          break;

        case "s8":
          e = [-128, 127];
          break;

        case "s16":
          e = [-32768, 32767];
          break;

        case "s32":
          e = [-2147483648, 2147483647];
          break;

        default:
          e = [-34e38, 34e38];
      }

      var _e = e,
          _e2 = _slicedToArray(_e, 2),
          s = _e2[0],
          i = _e2[1],
          r = this.pixels,
          l = this.width * this.height,
          a = r.length;

      var o, h, p;
      var c = [];

      for (var _u = 0; _u < a; _u++) {
        p = _n.createEmptyBand(t, l), o = r[_u];

        for (var _t = 0; _t < l; _t++) {
          h = o[_t], p[_t] = h > i ? i : h < s ? s : h;
        }

        c.push(p);
      }

      this.pixels = c, this.pixelType = t;
    }
  }, {
    key: "extractBands",
    value: function extractBands(t) {
      var _this3 = this;

      if (l(t) || 0 === t.length || null == this.pixels || 0 === this.pixels.length) return this;
      var e = this.pixels.length,
          s = t.some(function (t) {
        return t >= _this3.pixels.length;
      }),
          i = e === t.length && !t.some(function (t, e) {
        return t !== e;
      });
      return s || i ? this : new _n({
        pixelType: this.pixelType,
        width: this.width,
        height: this.height,
        mask: this.mask,
        validPixelCount: this.validPixelCount,
        maskIsAlpha: this.maskIsAlpha,
        pixels: t.map(function (t) {
          return _this3.pixels[t];
        }),
        statistics: this.statistics && t.map(function (t) {
          return _this3.statistics[t];
        })
      });
    }
  }, {
    key: "clone",
    value: function clone() {
      var t = new _n({
        width: this.width,
        height: this.height,
        pixelType: this.pixelType,
        maskIsAlpha: this.maskIsAlpha,
        validPixelCount: this.validPixelCount
      });
      var e;
      this.mask && (this.mask instanceof Uint8Array ? t.mask = new Uint8Array(this.mask) : t.mask = this.mask.slice(0));

      var s = _n.getPixelArrayConstructor(this.pixelType);

      if (this.pixels && this.pixels.length > 0) {
        t.pixels = [];
        var _i = this.pixels[0].slice;

        for (e = 0; e < this.pixels.length; e++) {
          t.pixels[e] = _i ? this.pixels[e].slice(0, this.pixels[e].length) : new s(this.pixels[e]);
        }
      }

      if (this.statistics) for (t.statistics = [], e = 0; e < this.statistics.length; e++) {
        t.statistics[e] = i(this.statistics[e]);
      }
      return t;
    }
  }, {
    key: "_fillFrom8Bit",
    value: function _fillFrom8Bit(t) {
      var e = this.mask,
          s = this.maskIsAlpha,
          i = this.pixels;
      if (!t || !i || !i.length) return void p.error("getAsRGBA()", "Unable to convert to RGBA. The input pixel block is empty.");
      var r, l, a, o;
      r = l = a = i[0], i.length >= 3 ? (l = i[1], a = i[2]) : 2 === i.length && (l = i[1]);

      var h = new Uint32Array(t),
          _n2 = this.width * this.height;

      if (r.length === _n2) {
        if (e && e.length === _n2) {
          if (s) for (o = 0; o < _n2; o++) {
            e[o] && (h[o] = e[o] << 24 | a[o] << 16 | l[o] << 8 | r[o]);
          } else for (o = 0; o < _n2; o++) {
            e[o] && (h[o] = 255 << 24 | a[o] << 16 | l[o] << 8 | r[o]);
          }
        } else for (o = 0; o < _n2; o++) {
          h[o] = 255 << 24 | a[o] << 16 | l[o] << 8 | r[o];
        }
      } else p.error("getAsRGBA()", "Unable to convert to RGBA. The pixelblock is invalid.");
    }
  }, {
    key: "_fillFromNon8Bit",
    value: function _fillFromNon8Bit(t) {
      var e = this.pixels,
          s = this.mask,
          i = this.statistics;
      if (!t || !e || !e.length) return void p.error("getAsRGBA()", "Unable to convert to RGBA. The input pixel block is empty.");
      var r = this.pixelType;
      var l = 1,
          a = 0,
          o = 1;
      if (i && i.length > 0) a = i.map(function (t) {
        return t.minValue;
      }).reduce(function (t, e) {
        return Math.min(t, e);
      }), o = i.map(function (t) {
        return t.maxValue - t.minValue;
      }).reduce(function (t, e) {
        return Math.max(t, e);
      }), l = 255 / o;else {
        var _t2 = 255;
        "s8" === r ? (a = -128, _t2 = 127) : "u16" === r ? _t2 = 65535 : "s16" === r ? (a = -32768, _t2 = 32767) : "u32" === r ? _t2 = 4294967295 : "s32" === r ? (a = -2147483648, _t2 = 2147483647) : "f32" === r ? (a = -34e38, _t2 = 34e38) : "f64" === r && (a = -Number.MAX_VALUE, _t2 = Number.MAX_VALUE), l = 255 / (_t2 - a);
      }

      var h = new Uint32Array(t),
          _n3 = this.width * this.height;

      var c, u, m, x, f;
      if (c = u = m = e[0], c.length !== _n3) return p.error("getAsRGBA()", "Unable to convert to RGBA. The pixelblock is invalid.");
      if (e.length >= 2) {
        if (u = e[1], e.length >= 3 && (m = e[2]), s && s.length === _n3) for (x = 0; x < _n3; x++) {
          s[x] && (h[x] = 255 << 24 | (m[x] - a) * l << 16 | (u[x] - a) * l << 8 | (c[x] - a) * l);
        } else for (x = 0; x < _n3; x++) {
          h[x] = 255 << 24 | (m[x] - a) * l << 16 | (u[x] - a) * l << 8 | (c[x] - a) * l;
        }
      } else if (s && s.length === _n3) for (x = 0; x < _n3; x++) {
        f = (c[x] - a) * l, s[x] && (h[x] = 255 << 24 | f << 16 | f << 8 | f);
      } else for (x = 0; x < _n3; x++) {
        f = (c[x] - a) * l, h[x] = 255 << 24 | f << 16 | f << 8 | f;
      }
    }
  }, {
    key: "_fillFrom32Bit",
    value: function _fillFrom32Bit(t) {
      var e = this.pixels,
          s = this.mask;
      if (!t || !e || !e.length) return p.error("getAsRGBAFloat()", "Unable to convert to RGBA. The input pixel block is empty.");
      var i, r, l, a;
      i = r = l = e[0], e.length >= 3 ? (r = e[1], l = e[2]) : 2 === e.length && (r = e[1]);
      var o = this.width * this.height;
      if (i.length !== o) return p.error("getAsRGBAFloat()", "Unable to convert to RGBA. The pixelblock is invalid.");
      var h = 0;
      if (s && s.length === o) for (a = 0; a < o; a++) {
        t[h++] = i[a], t[h++] = r[a], t[h++] = l[a], t[h++] = 1 & s[a];
      } else for (a = 0; a < o; a++) {
        t[h++] = i[a], t[h++] = r[a], t[h++] = l[a], t[h++] = 1;
      }
    }
  }, {
    key: "_calculateBandStatistics",
    value: function _calculateBandStatistics(t, e) {
      var s = 1 / 0,
          i = -1 / 0;
      var r = t.length;
      var l,
          a = 0;
      if (e) for (l = 0; l < r; l++) {
        e[l] && (a = t[l], s = a < s ? a : s, i = a > i ? a : i);
      } else for (l = 0; l < r; l++) {
        a = t[l], s = a < s ? a : s, i = a > i ? a : i;
      }
      return {
        minValue: s,
        maxValue: i
      };
    }
  }], [{
    key: "createEmptyBand",
    value: function createEmptyBand(t, e) {
      return new (_n.getPixelArrayConstructor(t))(e);
    }
  }, {
    key: "getPixelArrayConstructor",
    value: function getPixelArrayConstructor(t) {
      var e;

      switch (t) {
        case "u1":
        case "u2":
        case "u4":
        case "u8":
          e = Uint8Array;
          break;

        case "u16":
          e = Uint16Array;
          break;

        case "u32":
        case "u32":
          e = Uint32Array;
          break;

        case "s8":
          e = Int8Array;
          break;

        case "s16":
          e = Int16Array;
          break;

        case "s32":
          e = Int32Array;
          break;

        case "f32":
        case "c64":
        case "c128":
        case "unknown":
          e = Float32Array;
          break;

        case "f64":
          e = Float64Array;
      }

      return e;
    }
  }]);

  return n;
}(s);

t([a({
  json: {
    write: !0
  }
})], c.prototype, "width", void 0), t([a({
  json: {
    write: !0
  }
})], c.prototype, "height", void 0), t([a({
  json: {
    write: !0
  }
})], c.prototype, "pixelType", void 0), t([o("pixelType")], c.prototype, "castPixelType", null), t([a({
  json: {
    write: !0
  }
})], c.prototype, "validPixelCount", void 0), t([a({
  json: {
    write: !0
  }
})], c.prototype, "mask", void 0), t([a({
  json: {
    write: !0
  }
})], c.prototype, "maskIsAlpha", void 0), t([a({
  json: {
    write: !0
  }
})], c.prototype, "pixels", void 0), t([a({
  json: {
    write: !0
  }
})], c.prototype, "statistics", void 0), c = _n = t([h("esri.layers.support.PixelBlock")], c);
var u = c;
export { u as default };